import { render, staticRenderFns } from "./InitSuccess.vue?vue&type=template&id=57354996&scoped=true&"
import script from "./InitSuccess.vue?vue&type=script&lang=js&"
export * from "./InitSuccess.vue?vue&type=script&lang=js&"
import style0 from "./InitSuccess.vue?vue&type=style&index=0&id=57354996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57354996",
  null
  
)

export default component.exports